import React from "react"
import { SvgDownload01 } from "@digits-shared/components/SVGIcons/line/Download01.svg"
import { SvgFileLock03 } from "@digits-shared/components/SVGIcons/line/FileLock03.svg"
import { DigitsButton } from "@digits-shared/DesignSystem/Button"
import { Menu, MenuContent, MenuItem, MenuTrigger } from "@digits-shared/DesignSystem/Menu"
import { DigitsTooltip } from "@digits-shared/DesignSystem/Tooltip"
import useSession from "@digits-shared/hooks/useSession"
import { AspectCode } from "@digits-shared/session/AspectCode"
import { useExportToCsv } from "src/frontend/components/OS/Applications/Shared/Accounting/Exports/hooks/useExportToCsv"
import { useExportToVault } from "src/frontend/components/OS/Applications/Shared/Accounting/Exports/hooks/useExportToVault"
import type { InlineMoreOptionsButtonProps } from "src/frontend/components/OS/Applications/Shared/Accounting/Exports/hooks/useExportVariables"
import type FrontendSession from "src/frontend/session"
import { useStopClickPropagation } from "src/shared/hooks/useStopClickPropagation"

export const ExportOptionsButton: React.FC<InlineMoreOptionsButtonProps> = (props) => {
  const { hasAccessToAspect } = useSession<FrontendSession>()
  const allowVaultExport = hasAccessToAspect(AspectCode.Vault)
  const exportToVault = useExportToVault(props)
  const downloadCsv = useExportToCsv(props)
  const stopPropagation = useStopClickPropagation()

  const downloadButton = (onClick: React.MouseEventHandler) => (
    <DigitsButton
      css="margin: -5px 0;"
      $circle
      $variant="ghost-dark"
      size="small"
      onClick={onClick}
    >
      <SvgDownload01 />
    </DigitsButton>
  )

  if (!allowVaultExport) {
    return <DigitsTooltip content="Download CSV">{downloadButton(downloadCsv)}</DigitsTooltip>
  }

  return (
    <Menu>
      <MenuTrigger asChild>{downloadButton(stopPropagation)}</MenuTrigger>

      <MenuContent>
        <MenuItem label="Download CSV" onSelect={downloadCsv} Icon={SvgDownload01} />
        <MenuItem label="Export CSV to Documents" onSelect={exportToVault} Icon={SvgFileLock03} />
      </MenuContent>
    </Menu>
  )
}
